// import { yupResolver } from '@hookform/resolvers/yup';
// import CloseIcon from '@mui/icons-material/Close';
// import {
//   Alert,
//   Avatar,
//   Box,
//   Button,
//   CircularProgress,
//   Divider,
//   FormControl,
//   FormControlLabel,
//   Grid,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Radio,
//   RadioGroup,
//   TextField,
//   Typography,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import { AppDispatch, RootState } from 'app/store';
// import React, { useEffect, useRef, useState } from 'react';
// import { Controller, useForm } from 'react-hook-form';
// import {
//   FaCalendarAlt,
//   FaCamera,
//   FaCheckCircle,
//   FaClock,
//   FaExclamationTriangle,
//   FaFileAlt,
//   FaMapMarkerAlt,
//   FaSignature,
//   FaUndo,
//   FaUser,
//   FaUserShield,
//   FaUserTie
// } from 'react-icons/fa';
// import { FiArrowLeft } from 'react-icons/fi';
// import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { EmployeeIncident } from 'slices/NdisSlices/carporateServices/IncidentsListSlice';
// import {
//   clearEmployeeIncidentState,
//   EmployeeIncidentFormData,
//   submitEmployeeIncident
// } from 'slices/NdisSlices/reportAllForms/employeeIncidentSlice';
// import * as yup from 'yup';

// // Validation schemas
// const mainSchema = yup
//   .object({
//     id: yup.string().optional(),
//     date: yup.string().required('Date of incident is required'),
//     time: yup.string().required('Time of incident is required'),
//     location: yup.string().required('Location is required'),
//     employee_name: yup.string().required('Employee name is required'),
//     job_title: yup.string().required('Job title is required'),
//     description: yup.string().required('Incident description is required'),
//     other_individuals: yup.string().optional().default(''),
//     witnesses: yup.string().required('Please specify if there were witnesses'),
//     witness_contacts: yup.string().when('witnesses', {
//       is: 'Yes',
//       then: (schema) => schema.required('Witness contact is required'),
//       otherwise: (schema) => schema.optional().default('')
//     }),
//     immediate_actions: yup.string().required('Immediate actions taken is required'),
//     reported_to_management: yup.string().optional().default(''),
//     manager_name: yup.string().optional().default(''),
//     reporting_datetime: yup.string().optional().default(''),
//     recommendations: yup.string().optional().default(''),
//     employee_signature: yup.string().required('Signature is required'),
//     date_completed: yup.string().required('Date completed is required'),
//     photo: yup.mixed<File>().optional().default(undefined),
//     client_email: yup.string().optional().default('')
//   })
//   .required();

// const followUpSchema = yup
//   .object({
//     id: yup.string().optional(),
//     date: yup.string().optional().default(''),
//     time: yup.string().optional().default(''),
//     location: yup.string().optional().default(''),
//     employee_name: yup.string().optional().default(''),
//     job_title: yup.string().optional().default(''),
//     description: yup.string().optional().default(''),
//     other_individuals: yup.string().optional().default(''),
//     witnesses: yup.string().optional().default(''),
//     witness_contacts: yup.string().optional().default(''),
//     immediate_actions: yup.string().optional().default(''),
//     reported_to_management: yup.string().required('Please specify if reported to management'),
//     manager_name: yup.string().when('reported_to_management', {
//       is: 'Yes',
//       then: (schema) => schema.required('Manager name is required'),
//       otherwise: (schema) => schema.optional().default('')
//     }),
//     reporting_datetime: yup.string().when('reported_to_management', {
//       is: 'Yes',
//       then: (schema) => schema.required('Date/time of reporting is required'),
//       otherwise: (schema) => schema.optional().default('')
//     }),
//     recommendations: yup.string().required('Recommendations are required'),
//     employee_signature: yup.string().optional().default(''),
//     date_completed: yup.string().optional().default(''),
//     photo: yup.mixed<File>().optional().default(undefined),
//     client_email: yup.string().optional().default('')
//   })
//   .required();

// interface Props {
//   initialData?: EmployeeIncident;
//   onClose?: () => void;
// }

// const EmployeeIncidentReportForm: React.FC<Props> = ({ initialData, onClose }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
//   const dispatch = useDispatch<AppDispatch>();
//   const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
//   const { message, loading, error } = useTypedSelector((state) => state.employeeIncident);
//   const [previewImage, setPreviewImage] = useState<string | null>(null);
//   const fileInputRef = useRef<HTMLInputElement>(null);
//   const navigate = useNavigate();
//   const location = useLocation();

//   const searchParams = new URLSearchParams(location.search);
//   const tabParam = searchParams.get('tab') || 'incidents';
//   const incidentId = initialData?.id || undefined;

//   // Determine which form section to show based on route
//   const isMainFormRoute = location.pathname === '/employee-IncidentReport';
//   const isFollowUpRoute =
//     location.pathname === '/ndis-operations/corporate-services' && tabParam === 'incidents';

//   // Use separate useForm hooks for each route
//   const mainForm = useForm<EmployeeIncidentFormData>({
//     resolver: yupResolver(mainSchema) as any,
//     defaultValues: {
//       id: initialData?.id || '',
//       date: initialData?.date || '',
//       time: initialData?.time || '',
//       location: initialData?.location || '',
//       employee_name: initialData?.employee_name || '',
//       job_title: initialData?.job_title || '',
//       description: initialData?.description || '',
//       other_individuals: initialData?.other_individuals || '',
//       witnesses: initialData?.witnesses || '',
//       witness_contacts: initialData?.witness_contacts || '',
//       immediate_actions: initialData?.immediate_actions || '',
//       reported_to_management: initialData?.reported_to_management || '',
//       manager_name: initialData?.manager_name || '',
//       reporting_datetime: initialData?.reporting_datetime || '',
//       recommendations: initialData?.recommendations || '',
//       employee_signature: initialData?.employee_signature || '',
//       date_completed: initialData?.date_completed || '',
//       photo: undefined,
//       client_email: ''
//     }
//   });

//   const followUpForm = useForm<EmployeeIncidentFormData>({
//     resolver: yupResolver(followUpSchema) as any,
//     defaultValues: {
//       id: initialData?.id || '',
//       date: initialData?.date || '',
//       time: initialData?.time || '',
//       location: initialData?.location || '',
//       employee_name: initialData?.employee_name || '',
//       job_title: initialData?.job_title || '',
//       description: initialData?.description || '',
//       other_individuals: initialData?.other_individuals || '',
//       witnesses: initialData?.witnesses || '',
//       witness_contacts: initialData?.witness_contacts || '',
//       immediate_actions: initialData?.immediate_actions || '',
//       reported_to_management: initialData?.reported_to_management || '',
//       manager_name: initialData?.manager_name || '',
//       reporting_datetime: initialData?.reporting_datetime || '',
//       recommendations: initialData?.recommendations || '',
//       employee_signature: initialData?.employee_signature || '',
//       date_completed: initialData?.date_completed || '',
//       photo: undefined,
//       client_email: ''
//     }
//   });

//   const witnesses = isMainFormRoute ? mainForm.watch('witnesses') : followUpForm.watch('witnesses');
//   const reported_to_management = isMainFormRoute
//     ? mainForm.watch('reported_to_management')
//     : followUpForm.watch('reported_to_management');

//   const handleImageChange = (
//     e: React.ChangeEvent<HTMLInputElement>,
//     onChange: (value: File | undefined) => void
//   ) => {
//     const files = e.target.files;
//     if (files && files.length > 0) {
//       const file = files[0];
//       onChange(file);
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setPreviewImage(reader.result as string);
//       };
//       reader.readAsDataURL(file);
//     } else {
//       setPreviewImage(null);
//       onChange(undefined);
//     }
//   };

//   const handleRemoveImage = () => {
//     setPreviewImage(null);
//     if (isMainFormRoute) {
//       mainForm.setValue('photo', undefined, { shouldValidate: true });
//     } else {
//       followUpForm.setValue('photo', undefined, { shouldValidate: true });
//     }
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   const onSubmitMain = (data: EmployeeIncidentFormData) => {
//     const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//       email?: string;
//     };
//     const client_email = selectedClient.email || '';
//     const payload: EmployeeIncidentFormData = {
//       ...data,
//       client_email
//     };

//     dispatch(submitEmployeeIncident(payload))
//       .unwrap()
//       .then(() => {
//         mainForm.reset();
//         setPreviewImage(null);
//         if (fileInputRef.current) {
//           fileInputRef.current.value = '';
//         }
//         setTimeout(() => dispatch(clearEmployeeIncidentState()), 5000);
//       });
//   };

//   const onSubmitFollowUp = (data: EmployeeIncidentFormData) => {
//     const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//       email?: string;
//     };
//     const client_email = selectedClient.email || '';
//     const payload: EmployeeIncidentFormData = {
//       id: incidentId || initialData?.id,
//       date: initialData?.date || data.date,
//       time: initialData?.time || data.time,
//       location: initialData?.location || data.location,
//       employee_name: initialData?.employee_name || data.employee_name,
//       job_title: initialData?.job_title || data.job_title,
//       description: initialData?.description || data.description,
//       other_individuals: initialData?.other_individuals || data.other_individuals,
//       witnesses: initialData?.witnesses || data.witnesses,
//       witness_contacts: initialData?.witness_contacts || data.witness_contacts,
//       immediate_actions: initialData?.immediate_actions || data.immediate_actions,
//       reported_to_management: data.reported_to_management,
//       manager_name: data.manager_name,
//       reporting_datetime: data.reporting_datetime,
//       recommendations: data.recommendations,
//       employee_signature: initialData?.employee_signature || data.employee_signature,
//       date_completed: initialData?.date_completed || data.date_completed,
//       photo: initialData?.photo || '',
//       client_email
//     };

//     dispatch(submitEmployeeIncident(payload))
//       .unwrap()
//       .then(() => {
//         followUpForm.reset();
//         setPreviewImage(null);
//         if (fileInputRef.current) {
//           fileInputRef.current.value = '';
//         }
//         setTimeout(() => dispatch(clearEmployeeIncidentState()), 5000);
//         if (onClose) {
//           onClose();
//         }
//       });
//   };

//   const handleResetMain = (e: React.MouseEvent<HTMLButtonElement>) => {
//     e.preventDefault();
//     mainForm.reset();
//     setPreviewImage(null);
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//     dispatch(clearEmployeeIncidentState());
//   };

//   const handleResetFollowUp = (e: React.MouseEvent<HTMLButtonElement>) => {
//     e.preventDefault();
//     followUpForm.reset();
//     setPreviewImage(null);
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//     dispatch(clearEmployeeIncidentState());
//   };

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   }, []);

//   return (
//     <Box>
//       <Paper
//         elevation={isMobile ? 1 : 4}
//         sx={{
//           p: isMobile ? 2 : 4,
//           borderRadius: 2,
//           boxShadow: isMobile ? theme.shadows[1] : theme.shadows[4]
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             position: 'relative',
//             textAlign: 'center',
//             mb: isMobile ? 2 : 4,
//             px: isMobile ? 1 : 0
//           }}
//         >
//           {!isFollowUpRoute && (
//             <Button
//               onClick={() => navigate(-1)}
//               variant="outlined"
//               startIcon={<FiArrowLeft />}
//               sx={{
//                 position: 'absolute',
//                 left: 0,
//                 top: 0,
//                 borderColor:
//                   theme.palette.mode === 'light'
//                     ? 'rgba(0, 0, 0, 0.23)'
//                     : 'rgba(255, 255, 255, 0.23)',
//                 color: theme.palette.text.primary,
//                 textTransform: 'none',
//                 borderRadius: 2,
//                 px: 2,
//                 py: 1,
//                 '&:hover': {
//                   borderColor: theme.palette.primary.main,
//                   backgroundColor: theme.palette.action.hover
//                 },
//                 ...(isMobile && {
//                   fontSize: '0.75rem',
//                   px: 1.5,
//                   py: 0.5
//                 })
//               }}
//             >
//               {isMobile ? 'Back' : 'Back to Forms'}
//             </Button>
//           )}

//           <Box
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               mb: 1,
//               flexDirection: isMobile ? 'column' : 'row',
//               mt: isMobile && !isFollowUpRoute ? 4 : 0,
//               gap: isMobile ? 1 : 2
//             }}
//           >
//             <Box
//               sx={{
//                 backgroundColor: theme.palette.primary.light,
//                 p: 1.5,
//                 borderRadius: '50%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//               }}
//             >
//               <FaFileAlt
//                 size={isMobile ? 24 : 32}
//                 style={{
//                   color: theme.palette.primary.dark
//                 }}
//               />
//             </Box>
//             <Typography
//               variant={isMobile ? 'h5' : 'h4'}
//               component="h1"
//               sx={{
//                 fontWeight: 600,
//                 lineHeight: 1.2,
//                 color: theme.palette.text.primary
//               }}
//             >
//               {isMainFormRoute ? 'Employee Incident Report' : 'Employee Incident Follow-Up Form'}
//             </Typography>
//           </Box>

//           <Typography
//             variant={isMobile ? 'body2' : 'subtitle1'}
//             sx={{
//               color: 'text.secondary',
//               maxWidth: 600,
//               margin: '0 auto',
//               px: isMobile ? 1 : 2,
//               lineHeight: 1.4
//             }}
//           >
//             Ultra Care Services -{' '}
//             {isMainFormRoute
//               ? 'To be completed when involved in or witnessing an incident'
//               : 'For follow-up actions on employee incidents'}
//           </Typography>
//         </Box>

//         {/* Success/Error Messages */}
//         {message && (
//           <Alert
//             severity="success"
//             sx={{ mb: 2 }}
//             onClose={() => dispatch(clearEmployeeIncidentState())}
//           >
//             {message}
//           </Alert>
//         )}
//         {error && (
//           <Alert
//             severity="error"
//             sx={{ mb: 2 }}
//             onClose={() => dispatch(clearEmployeeIncidentState())}
//           >
//             {error}
//           </Alert>
//         )}

//         {isMainFormRoute && (
//           <form onSubmit={mainForm.handleSubmit(onSubmitMain)}>
//             {/* General Information */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaUserTie
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   General Information
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="date"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Date of Incident"
//                         type="date"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaCalendarAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.date}
//                         helperText={mainForm.formState.errors.date?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="time"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Time of Incident"
//                         type="time"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaClock size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.time}
//                         helperText={mainForm.formState.errors.time?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="location"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Location"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaMapMarkerAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.location}
//                         helperText={mainForm.formState.errors.location?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="employee_name"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Employee's Name"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaUser size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.employee_name}
//                         helperText={mainForm.formState.errors.employee_name?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="job_title"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Job Title"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaUserTie size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.job_title}
//                         helperText={mainForm.formState.errors.job_title?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Incident Details */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaExclamationTriangle
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.error.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Incident Details
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="description"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Description of the Incident"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!mainForm.formState.errors.description}
//                         helperText={mainForm.formState.errors.description?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="other_individuals"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Other Individuals Involved (if any)"
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!mainForm.formState.errors.other_individuals}
//                         helperText={mainForm.formState.errors.other_individuals?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Were There Any Witnesses?
//                     </Typography>
//                     <Controller
//                       name="witnesses"
//                       control={mainForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2
//                           }}
//                         >
//                           <FormControlLabel
//                             value="No"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Yes"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {mainForm.formState.errors.witnesses && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {mainForm.formState.errors.witnesses.message as string}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Grid>
//                 {witnesses === 'Yes' && (
//                   <Grid item xs={12}>
//                     <Controller
//                       name="witness_contacts"
//                       control={mainForm.control}
//                       render={({ field }) => (
//                         <TextField
//                           size="small"
//                           label="Witness Names and Contact Information"
//                           fullWidth
//                           margin="normal"
//                           {...field}
//                           error={!!mainForm.formState.errors.witness_contacts}
//                           helperText={mainForm.formState.errors.witness_contacts?.message as string}
//                         />
//                       )}
//                     />
//                   </Grid>
//                 )}
//                 <Grid item xs={12}>
//                   <Controller
//                     name="immediate_actions"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Immediate Actions Taken"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!mainForm.formState.errors.immediate_actions}
//                         helperText={mainForm.formState.errors.immediate_actions?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="photo"
//                     control={mainForm.control}
//                     render={({ field: { onChange, onBlur, ...field } }) => (
//                       <Box>
//                         <TextField
//                           size="small"
//                           label="Upload Photo"
//                           type="file"
//                           fullWidth
//                           margin="normal"
//                           inputRef={fileInputRef}
//                           InputLabelProps={{ shrink: true }}
//                           InputProps={{
//                             startAdornment: (
//                               <InputAdornment position="start">
//                                 <FaCamera size={16} />
//                               </InputAdornment>
//                             ),
//                             inputProps: {
//                               accept: 'image/*'
//                             }
//                           }}
//                           onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
//                             handleImageChange(e, onChange)
//                           }
//                           onBlur={onBlur}
//                           error={!!mainForm.formState.errors.photo}
//                           helperText={mainForm.formState.errors.photo?.message as string}
//                         />
//                         {previewImage && isLargeScreen && (
//                           <Box sx={{ mt: 1, textAlign: 'left' }}>
//                             <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                               Photo Preview
//                             </Typography>
//                             <Box sx={{ position: 'relative', display: 'inline-block' }}>
//                               <Avatar
//                                 src={previewImage}
//                                 variant="rounded"
//                                 sx={{
//                                   width: isMobile ? '100%' : 150,
//                                   height: 150,
//                                   objectFit: 'contain'
//                                 }}
//                               />
//                               <IconButton
//                                 size="small"
//                                 onClick={handleRemoveImage}
//                                 sx={{
//                                   position: 'absolute',
//                                   top: -10,
//                                   right: -10,
//                                   bgcolor: theme.palette.error.main,
//                                   color: theme.palette.common.white,
//                                   '&:hover': {
//                                     bgcolor: theme.palette.error.dark
//                                   }
//                                 }}
//                               >
//                                 <CloseIcon fontSize="small" />
//                               </IconButton>
//                             </Box>
//                           </Box>
//                         )}
//                       </Box>
//                     )}
//                   />
//                 </Grid>
//                 {previewImage && !isLargeScreen && (
//                   <Grid item xs={12}>
//                     <Box
//                       sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start' }}
//                     >
//                       <Box sx={{ position: 'relative' }}>
//                         <Avatar
//                           src={previewImage}
//                           variant="rounded"
//                           sx={{
//                             width: isMobile ? '100%' : 150,
//                             height: isMobile ? 150 : 150,
//                             mt: isMobile ? 1 : 0,
//                             objectFit: 'contain'
//                           }}
//                         />
//                         <IconButton
//                           size="small"
//                           onClick={handleRemoveImage}
//                           sx={{
//                             position: 'absolute',
//                             top: -10,
//                             right: -10,
//                             bgcolor: theme.palette.error.main,
//                             color: theme.palette.common.white,
//                             '&:hover': {
//                               bgcolor: theme.palette.error.dark
//                             }
//                           }}
//                         >
//                           <CloseIcon fontSize="small" />
//                         </IconButton>
//                       </Box>
//                     </Box>
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>

//             {/* Employee Details */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaUserShield
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Employee Details
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="employee_signature"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Employee's Signature"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaSignature size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.employee_signature}
//                         helperText={mainForm.formState.errors.employee_signature?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="date_completed"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Date Completed"
//                         type="date"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaCalendarAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.date_completed}
//                         helperText={mainForm.formState.errors.date_completed?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Submit and Reset Buttons */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: isMobile ? 2 : 3,
//                 mt: isMobile ? 3 : 4,
//                 mb: isMobile ? 1 : 0,
//                 flexDirection: isMobile ? 'column' : 'row'
//               }}
//             >
//               <Button
//                 type="button"
//                 variant="outlined"
//                 color="secondary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaUndo size={isMobile ? 14 : 18} />}
//                 onClick={handleResetMain}
//                 disabled={!mainForm.formState.isDirty || loading}
//               >
//                 Reset Form
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
//                 disabled={loading}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Submit Report'}
//               </Button>
//             </Box>
//           </form>
//         )}

//         {isFollowUpRoute && (
//           <form onSubmit={followUpForm.handleSubmit(onSubmitFollowUp)}>
//             {/* Follow-Up Actions */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaCheckCircle
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.success.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Follow-Up Actions
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Was the Incident Reported to Management?
//                     </Typography>
//                     <Controller
//                       name="reported_to_management"
//                       control={followUpForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2
//                           }}
//                         >
//                           <FormControlLabel
//                             value="No"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Yes"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {followUpForm.formState.errors.reported_to_management && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {followUpForm.formState.errors.reported_to_management.message as string}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Grid>
//                 {reported_to_management === 'Yes' && (
//                   <>
//                     <Grid item xs={12} sm={6}>
//                       <Controller
//                         name="manager_name"
//                         control={followUpForm.control}
//                         render={({ field }) => (
//                           <TextField
//                             size="small"
//                             label="Manager's Name"
//                             fullWidth
//                             margin="normal"
//                             {...field}
//                             error={!!followUpForm.formState.errors.manager_name}
//                             helperText={
//                               followUpForm.formState.errors.manager_name?.message as string
//                             }
//                           />
//                         )}
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Controller
//                         name="reporting_datetime"
//                         control={followUpForm.control}
//                         render={({ field }) => (
//                           <TextField
//                             size="small"
//                             label="Date and Time of Reporting"
//                             type="datetime-local"
//                             fullWidth
//                             margin="normal"
//                             InputLabelProps={{ shrink: true }}
//                             {...field}
//                             error={!!followUpForm.formState.errors.reporting_datetime}
//                             helperText={
//                               followUpForm.formState.errors.reporting_datetime?.message as string
//                             }
//                           />
//                         )}
//                       />
//                     </Grid>
//                   </>
//                 )}
//                 <Grid item xs={12}>
//                   <Controller
//                     name="recommendations"
//                     control={followUpForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Recommendations to Prevent Future Incidents"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!followUpForm.formState.errors.recommendations}
//                         helperText={
//                           followUpForm.formState.errors.recommendations?.message as string
//                         }
//                       />
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Submit and Reset Buttons */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: isMobile ? 2 : 3,
//                 mt: isMobile ? 3 : 4,
//                 mb: isMobile ? 1 : 0,
//                 flexDirection: isMobile ? 'column' : 'row'
//               }}
//             >
//               <Button
//                 type="button"
//                 variant="outlined"
//                 color="secondary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaUndo size={isMobile ? 14 : 18} />}
//                 onClick={handleResetFollowUp}
//                 disabled={!followUpForm.formState.isDirty || loading}
//               >
//                 Reset Form
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
//                 disabled={loading || !incidentId}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Submit Follow-Up'}
//               </Button>
//             </Box>
//           </form>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default EmployeeIncidentReportForm;

import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import {
  Alert,
  Avatar,
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { AppDispatch, RootState } from 'app/store';
import React, { useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import {
  FaCalendarAlt,
  FaCamera,
  FaCheckCircle,
  FaClock,
  FaExclamationTriangle,
  FaFileAlt,
  FaMapMarkerAlt,
  FaSignature,
  FaUndo,
  FaUser,
  FaUserShield,
  FaUserTie
} from 'react-icons/fa';
import { FiArrowLeft } from 'react-icons/fi';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { EmployeeIncident } from 'slices/NdisSlices/carporateServices/IncidentsListSlice';
import {
  clearEmployeeIncidentState,
  EmployeeIncidentFormData,
  submitEmployeeIncident
} from 'slices/NdisSlices/reportAllForms/employeeIncidentSlice';
import * as yup from 'yup';

// Validation schemas
const mainSchema = yup
  .object({
    id: yup.string().optional(),
    date: yup.string().required('Date of incident is required'),
    time: yup.string().required('Time of incident is required'),
    location: yup.string().required('Location is required'),
    employee_name: yup.string().required('Employee name is required'),
    job_title: yup.string().required('Job title is required'),
    description: yup.string().required('Incident description is required'),
    other_individuals: yup.string().optional().default(''),
    witnesses: yup.string().required('Please specify if there were witnesses'),
    witness_contacts: yup.string().when('witnesses', {
      is: 'Yes',
      then: (schema) => schema.required('Witness contact is required'),
      otherwise: (schema) => schema.optional().default('')
    }),
    immediate_actions: yup.string().required('Immediate actions taken is required'),
    reported_to_management: yup.string().optional().default(''),
    manager_name: yup.string().optional().default(''),
    reporting_datetime: yup.string().optional().default(''),
    recommendations: yup.string().optional().default(''),
    employee_signature: yup.string().required('Signature is required'),
    date_completed: yup.string().required('Date completed is required'),
    photo: yup.mixed<File>().optional().default(undefined),
    client_email: yup.string().optional().default('')
  })
  .required();

const followUpSchema = yup
  .object({
    id: yup.string().optional(),
    date: yup.string().optional().default(''),
    time: yup.string().optional().default(''),
    location: yup.string().optional().default(''),
    employee_name: yup.string().optional().default(''),
    job_title: yup.string().optional().default(''),
    description: yup.string().optional().default(''),
    other_individuals: yup.string().optional().default(''),
    witnesses: yup.string().optional().default(''),
    witness_contacts: yup.string().optional().default(''),
    immediate_actions: yup.string().optional().default(''),
    reported_to_management: yup.string().required('Please specify if reported to management'),
    manager_name: yup.string().when('reported_to_management', {
      is: 'Yes',
      then: (schema) => schema.required('Manager name is required'),
      otherwise: (schema) => schema.optional().default('')
    }),
    reporting_datetime: yup.string().when('reported_to_management', {
      is: 'Yes',
      then: (schema) => schema.required('Date/time of reporting is required'),
      otherwise: (schema) => schema.optional().default('')
    }),
    resolved: yup
      .string()
      .oneOf(['Yes', 'No'], 'Please specify if the incident is resolved')
      .required('Please specify if the incident is resolved'),
    recommendations: yup.string().required('Recommendations are required'),
    employee_signature: yup.string().optional().default(''),
    date_completed: yup.string().optional().default(''),
    photo: yup.mixed<File>().optional().default(undefined),
    client_email: yup.string().optional().default('')
  })
  .required();

interface Props {
  initialData?: EmployeeIncident;
  onClose?: () => void;
}

const EmployeeIncidentReportForm: React.FC<Props> = ({ initialData, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const dispatch = useDispatch<AppDispatch>();
  const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
  const { message, loading, error } = useTypedSelector((state) => state.employeeIncident);
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const tabParam = searchParams.get('tab') || 'incidents';
  const incidentId = initialData?.id || undefined;

  const isFollowUpRoute =
    location.pathname === '/ndis-operations/corporate-services' && tabParam === 'incidents';
  // Check if Follow-Up form is already filled
  const [alreadyFilled, setAlreadyFilled] = useState(false);
  useEffect(() => {
    if (isFollowUpRoute && initialData) {
      const isFilled = [
        initialData.reported_to_management,
        initialData.manager_name,
        initialData.reporting_datetime,
        initialData.recommendations,
        initialData.resolved // Added resolved to check
      ].some((field) => field !== undefined && field !== null && field !== '');
      setAlreadyFilled(isFilled);
    } else {
      setAlreadyFilled(false);
    }
  }, [initialData, isFollowUpRoute]);

  // Determine which form section to show based on route
  const isMainFormRoute = location.pathname === '/employee-IncidentReport';


  // Use separate useForm hooks for each route
  const defaultDateTime = new Date().toISOString().split('T')[0];
  const mainForm = useForm<EmployeeIncidentFormData>({
    resolver: yupResolver(mainSchema) as any,
    defaultValues: {
      id: initialData?.id || '',
      date: initialData?.date || defaultDateTime,
      time: initialData?.time || '',
      location: initialData?.location || '',
      employee_name: initialData?.employee_name || '',
      job_title: initialData?.job_title || '',
      description: initialData?.description || '',
      other_individuals: initialData?.other_individuals || '',
      witnesses: initialData?.witnesses || '',
      witness_contacts: initialData?.witness_contacts || '',
      immediate_actions: initialData?.immediate_actions || '',
      reported_to_management: initialData?.reported_to_management || '',
      manager_name: initialData?.manager_name || '',
      reporting_datetime: initialData?.reporting_datetime || '',
      recommendations: initialData?.recommendations || '',
      employee_signature: initialData?.employee_signature || '',
      date_completed: initialData?.date_completed || defaultDateTime,
      photo: undefined,
      client_email: ''
    }
  });

  const followUpForm = useForm<EmployeeIncidentFormData>({
    resolver: yupResolver(followUpSchema) as any,
    defaultValues: {
      id: initialData?.id || '',
      date: initialData?.date || '',
      time: initialData?.time || '',
      location: initialData?.location || '',
      employee_name: initialData?.employee_name || '',
      job_title: initialData?.job_title || '',
      description: initialData?.description || '',
      other_individuals: initialData?.other_individuals || '',
      witnesses: initialData?.witnesses || '',
      witness_contacts: initialData?.witness_contacts || '',
      immediate_actions: initialData?.immediate_actions || '',
      reported_to_management: initialData?.reported_to_management || '',
      manager_name: initialData?.manager_name || '',
      reporting_datetime: initialData?.reporting_datetime || '',
      recommendations: initialData?.recommendations || '',
      resolved: initialData?.resolved || '', // Initialize resolved
      employee_signature: initialData?.employee_signature || '',
      date_completed: initialData?.date_completed || defaultDateTime,
      photo: undefined,
      client_email: ''
    }
  });

  const witnesses = isMainFormRoute ? mainForm.watch('witnesses') : followUpForm.watch('witnesses');
  const reported_to_management = isMainFormRoute
    ? mainForm.watch('reported_to_management')
    : followUpForm.watch('reported_to_management');

  const handleImageChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    onChange: (value: File | undefined) => void
  ) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      onChange(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result as string);
      };
      reader.readAsDataURL(file);
    } else {
      setPreviewImage(null);
      onChange(undefined);
    }
  };

  const handleRemoveImage = () => {
    setPreviewImage(null);
    if (isMainFormRoute) {
      mainForm.setValue('photo', undefined, { shouldValidate: true });
    } else {
      followUpForm.setValue('photo', undefined, { shouldValidate: true });
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const onSubmitMain = (data: EmployeeIncidentFormData) => {
    const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
      email?: string;
    };
    const client_email = selectedClient.email || '';
    const payload: EmployeeIncidentFormData = {
      ...data,
      client_email
    };

    dispatch(submitEmployeeIncident(payload))
      .unwrap()
      .then(() => {
        mainForm.reset();
        setPreviewImage(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
        setTimeout(() => dispatch(clearEmployeeIncidentState()), 5000);
      });
  };

  const onSubmitFollowUp = (data: EmployeeIncidentFormData) => {
    const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
      email?: string;
    };
    const client_email = selectedClient.email || '';
    const payload: EmployeeIncidentFormData = {
      id: incidentId || initialData?.id,
      date: initialData?.date || data.date,
      time: initialData?.time || data.time,
      location: initialData?.location || data.location,
      employee_name: initialData?.employee_name || data.employee_name,
      job_title: initialData?.job_title || data.job_title,
      description: initialData?.description || data.description,
      other_individuals: initialData?.other_individuals || data.other_individuals,
      witnesses: initialData?.witnesses || data.witnesses,
      witness_contacts: initialData?.witness_contacts || data.witness_contacts,
      immediate_actions: initialData?.immediate_actions || data.immediate_actions,
      reported_to_management: data.reported_to_management,
      manager_name: data.manager_name,
      reporting_datetime: data.reporting_datetime,
      recommendations: data.recommendations,
      resolved: data.resolved, // Include resolved in payload
      employee_signature: initialData?.employee_signature || data.employee_signature,
      date_completed: initialData?.date_completed || data.date_completed,
      photo: initialData?.photo || '',
      client_email
    };

    dispatch(submitEmployeeIncident(payload))
      .unwrap()
      .then(() => {
        followUpForm.reset();
        setPreviewImage(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
        setTimeout(() => dispatch(clearEmployeeIncidentState()), 5000);
        if (onClose) {
          onClose();
        }
      });
  };

  const handleResetMain = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    mainForm.reset();
    setPreviewImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    dispatch(clearEmployeeIncidentState());
  };

  const handleResetFollowUp = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    followUpForm.reset();
    setPreviewImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    dispatch(clearEmployeeIncidentState());
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Box>
      <Paper
        elevation={isMobile ? 1 : 4}
        sx={{
          p: isMobile ? 2 : 4,
          borderRadius: 2,
          boxShadow: isMobile ? theme.shadows[1] : theme.shadows[4]
        }}
      >
        {/* Header */}
        <Box
          sx={{
            position: 'relative',
            textAlign: 'center',
            mb: isMobile ? 2 : 4,
            px: isMobile ? 1 : 0
          }}
        >
          {!isFollowUpRoute && (
            <Button
              onClick={() => navigate(-1)}
              variant="outlined"
              startIcon={<FiArrowLeft />}
              sx={{
                position: 'absolute',
                left: 0,
                top: 0,
                borderColor:
                  theme.palette.mode === 'light'
                    ? 'rgba(0, 0, 0, 0.23)'
                    : 'rgba(255, 255, 255, 0.23)',
                color: theme.palette.text.primary,
                textTransform: 'none',
                borderRadius: 2,
                px: 2,
                py: 1,
                '&:hover': {
                  borderColor: theme.palette.primary.main,
                  backgroundColor: theme.palette.action.hover
                },
                ...(isMobile && {
                  fontSize: '0.75rem',
                  px: 1.5,
                  py: 0.5
                })
              }}
            >
              {isMobile ? 'Back' : 'Back to Forms'}
            </Button>
          )}

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 1,
              flexDirection: isMobile ? 'column' : 'row',
              mt: isMobile && !isFollowUpRoute ? 4 : 0,
              gap: isMobile ? 1 : 2
            }}
          >
            <Box
              sx={{
                backgroundColor: theme.palette.primary.light,
                p: 1.5,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <FaFileAlt
                size={isMobile ? 24 : 32}
                style={{
                  color: theme.palette.primary.dark
                }}
              />
            </Box>
            <Typography
              variant={isMobile ? 'h5' : 'h4'}
              component="h1"
              sx={{
                fontWeight: 600,
                lineHeight: 1.2,
                color: theme.palette.text.primary
              }}
            >
              {isMainFormRoute ? 'Employee Incident Report' : 'Employee Incident Follow-Up Form'}
            </Typography>
          </Box>

          <Typography
            variant={isMobile ? 'body2' : 'subtitle1'}
            sx={{
              color: 'text.secondary',
              maxWidth: 600,
              margin: '0 auto',
              px: isMobile ? 1 : 2,
              lineHeight: 1.4
            }}
          >
            Ultra Care Services -{' '}
            {isMainFormRoute
              ? 'To be completed when involved in or witnessing an incident'
              : 'For follow-up actions on employee incidents'}
          </Typography>
        </Box>

        {/* Success/Error Messages */}
        {message && (
          <Alert
            severity="success"
            sx={{ mb: 2 }}
            onClose={() => dispatch(clearEmployeeIncidentState())}
          >
            {message}
          </Alert>
        )}
        {error && (
          <Alert
            severity="error"
            sx={{ mb: 2 }}
            onClose={() => dispatch(clearEmployeeIncidentState())}
          >
            {error}
          </Alert>
        )}
        {isFollowUpRoute && alreadyFilled && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            This follow-up form has already been filled.
          </Alert>
        )}

        {isMainFormRoute && (
          <form onSubmit={mainForm.handleSubmit(onSubmitMain)}>
            {/* General Information */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaUserTie
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  General Information
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="date"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Date of Incident"
                        type="date"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaCalendarAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.date}
                        helperText={mainForm.formState.errors.date?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="time"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Time of Incident"
                        type="time"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaClock size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.time}
                        helperText={mainForm.formState.errors.time?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="location"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Location"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaMapMarkerAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.location}
                        helperText={mainForm.formState.errors.location?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="employee_name"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Employee's Name"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaUser size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.employee_name}
                        helperText={mainForm.formState.errors.employee_name?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="job_title"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Job Title"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaUserTie size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.job_title}
                        helperText={mainForm.formState.errors.job_title?.message as string}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Incident Details */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaExclamationTriangle
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.error.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Incident Details
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <Controller
                    name="description"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Description of the Incident"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!mainForm.formState.errors.description}
                        helperText={mainForm.formState.errors.description?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="other_individuals"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Other Individuals Involved (if any)"
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!mainForm.formState.errors.other_individuals}
                        helperText={mainForm.formState.errors.other_individuals?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Were There Any Witnesses?
                    </Typography>
                    <Controller
                      name="witnesses"
                      control={mainForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {mainForm.formState.errors.witnesses && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {mainForm.formState.errors.witnesses.message as string}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                {witnesses === 'Yes' && (
                  <Grid item xs={12}>
                    <Controller
                      name="witness_contacts"
                      control={mainForm.control}
                      render={({ field }) => (
                        <TextField
                          size="small"
                          label="Witness Names and Contact Information"
                          fullWidth
                          margin="normal"
                          {...field}
                          error={!!mainForm.formState.errors.witness_contacts}
                          helperText={mainForm.formState.errors.witness_contacts?.message as string}
                        />
                      )}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Controller
                    name="immediate_actions"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Immediate Actions Taken"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!mainForm.formState.errors.immediate_actions}
                        helperText={mainForm.formState.errors.immediate_actions?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="photo"
                    control={mainForm.control}
                    render={({ field: { onChange, onBlur, ...field } }) => (
                      <Box>
                        <TextField
                          size="small"
                          label="Upload Photo"
                          type="file"
                          fullWidth
                          margin="normal"
                          inputRef={fileInputRef}
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <FaCamera size={16} />
                              </InputAdornment>
                            ),
                            inputProps: {
                              accept: 'image/*'
                            }
                          }}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            handleImageChange(e, onChange)
                          }
                          onBlur={onBlur}
                          error={!!mainForm.formState.errors.photo}
                          helperText={mainForm.formState.errors.photo?.message as string}
                        />
                        {previewImage && isLargeScreen && (
                          <Box sx={{ mt: 1, textAlign: 'left' }}>
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                              Photo Preview
                            </Typography>
                            <Box sx={{ position: 'relative', display: 'inline-block' }}>
                              <Avatar
                                src={previewImage}
                                variant="rounded"
                                sx={{
                                  width: isMobile ? '100%' : 150,
                                  height: 150,
                                  objectFit: 'contain'
                                }}
                              />
                              <IconButton
                                size="small"
                                onClick={handleRemoveImage}
                                sx={{
                                  position: 'absolute',
                                  top: -10,
                                  right: -10,
                                  bgcolor: theme.palette.error.main,
                                  color: theme.palette.common.white,
                                  '&:hover': {
                                    bgcolor: theme.palette.error.dark
                                  }
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </Box>
                        )}
                      </Box>
                    )}
                  />
                </Grid>
                {previewImage && !isLargeScreen && (
                  <Grid item xs={12}>
                    <Box
                      sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start' }}
                    >
                      <Box sx={{ position: 'relative' }}>
                        <Avatar
                          src={previewImage}
                          variant="rounded"
                          sx={{
                            width: isMobile ? '100%' : 150,
                            height: isMobile ? 150 : 150,
                            mt: isMobile ? 1 : 0,
                            objectFit: 'contain'
                          }}
                        />
                        <IconButton
                          size="small"
                          onClick={handleRemoveImage}
                          sx={{
                            position: 'absolute',
                            top: -10,
                            right: -10,
                            bgcolor: theme.palette.error.main,
                            color: theme.palette.common.white,
                            '&:hover': {
                              bgcolor: theme.palette.error.dark
                            }
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Box>

            {/* Employee Details */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaUserShield
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Employee Details
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="employee_signature"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Employee's Signature"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaSignature size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.employee_signature}
                        helperText={mainForm.formState.errors.employee_signature?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="date_completed"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Date Completed"
                        type="date"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaCalendarAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.date_completed}
                        helperText={mainForm.formState.errors.date_completed?.message as string}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Submit and Reset Buttons */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: isMobile ? 2 : 3,
                mt: isMobile ? 3 : 4,
                mb: isMobile ? 1 : 0,
                flexDirection: isMobile ? 'column' : 'row'
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaUndo size={isMobile ? 14 : 18} />}
                onClick={handleResetMain}
                disabled={!mainForm.formState.isDirty || loading}
              >
                Reset Form
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : 'Submit Report'}
              </Button>
            </Box>
          </form>
        )}

        {isFollowUpRoute && (
          <form onSubmit={followUpForm.handleSubmit(onSubmitFollowUp)}>
            {/* Follow-Up Actions */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaCheckCircle
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.success.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Follow-Up Actions
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Was the Incident Reported to Management?
                    </Typography>
                    <Controller
                      name="reported_to_management"
                      control={followUpForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {followUpForm.formState.errors.reported_to_management && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {followUpForm.formState.errors.reported_to_management.message as string}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                {reported_to_management === 'Yes' && (
                  <>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        name="manager_name"
                        control={followUpForm.control}
                        render={({ field }) => (
                          <TextField
                            size="small"
                            label="Manager's Name"
                            fullWidth
                            margin="normal"
                            {...field}
                            error={!!followUpForm.formState.errors.manager_name}
                            helperText={
                              followUpForm.formState.errors.manager_name?.message as string
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        name="reporting_datetime"
                        control={followUpForm.control}
                        render={({ field }) => (
                          <TextField
                            size="small"
                            label="Date and Time of Reporting"
                            type="datetime-local"
                            fullWidth
                            margin="normal"
                            InputLabelProps={{ shrink: true }}
                            {...field}
                            error={!!followUpForm.formState.errors.reporting_datetime}
                            helperText={
                              followUpForm.formState.errors.reporting_datetime?.message as string
                            }
                          />
                        )}
                      />
                    </Grid>
                  </>
                )}
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Is the Incident Resolved?
                    </Typography>
                    <Controller
                      name="resolved"
                      control={followUpForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {followUpForm.formState.errors.resolved && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {followUpForm.formState.errors.resolved.message as string}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="recommendations"
                    control={followUpForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Recommendations to Prevent Future Incidents"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!followUpForm.formState.errors.recommendations}
                        helperText={
                          followUpForm.formState.errors.recommendations?.message as string
                        }
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Submit and Reset Buttons */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: isMobile ? 2 : 3,
                mt: isMobile ? 3 : 4,
                mb: isMobile ? 1 : 0,
                flexDirection: isMobile ? 'column' : 'row'
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaUndo size={isMobile ? 14 : 18} />}
                onClick={handleResetFollowUp}
                disabled={!followUpForm.formState.isDirty || loading}
              >
                Reset Form
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
                disabled={loading || !incidentId || alreadyFilled}
              >
                {loading ? <CircularProgress size={24} /> : 'Submit Follow-Up'}
              </Button>
            </Box>
          </form>
        )}
      </Paper>
    </Box>
  );
};

export default EmployeeIncidentReportForm;